var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCerificated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5388 1.56339C13.3293 0.717576 14.6707 0.717575 15.4612 1.56339L17.3977 3.63535C17.7919 4.05721 18.3493 4.28807 18.9264 4.26857L21.7608 4.17278C22.9179 4.13368 23.8663 5.08214 23.8272 6.23919L23.7314 9.0736C23.7119 9.65069 23.9428 10.2081 24.3646 10.6023L26.4366 12.5388C27.2824 13.3293 27.2824 14.6707 26.4366 15.4612L24.3646 17.3977C23.9428 17.7919 23.7119 18.3493 23.7314 18.9264L23.8272 21.7608C23.8663 22.9179 22.9179 23.8663 21.7608 23.8272L18.9264 23.7314C18.3493 23.7119 17.7919 23.9428 17.3977 24.3646L15.4612 26.4366C14.6707 27.2824 13.3293 27.2824 12.5388 26.4366L10.6023 24.3646C10.2081 23.9428 9.6507 23.7119 9.0736 23.7314L6.23919 23.8272C5.08214 23.8663 4.13368 22.9179 4.17278 21.7608L4.26857 18.9264C4.28807 18.3493 4.05721 17.7919 3.63535 17.3977L1.56339 15.4612C0.717576 14.6707 0.717575 13.3293 1.56339 12.5388L3.63535 10.6023C4.05721 10.2081 4.28807 9.65069 4.26857 9.0736L4.17278 6.23919C4.13368 5.08214 5.08214 4.13368 6.23919 4.17278L9.0736 4.26857C9.65069 4.28807 10.2081 4.05721 10.6023 3.63535L12.5388 1.56339Z",
    fill: "#969EAD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 13.5L13 17.5L19.5 10",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCerificated);
export default __webpack_public_path__ + "static/media/iconCerificated.fdc0b3a96d447dd3a8475943edfe407d.svg";
export { ForwardRef as ReactComponent };